// stores/menuStore.ts
import { defineStore } from 'pinia'
import { processMenusForSidebar } from '@/utils/addRoutes'
import { ref } from 'vue'

export const useMenuStore = defineStore('menu', () => {
  // 原始菜单数据
  const rawMenus = ref<any[]>([])
  // 处理后的侧边栏菜单数据
  const sidebarMenus = ref<any[]>([])
  // 菜单加载状态
  const menusLoaded = ref(false)

  // 设置菜单数据
  const setMenus = (menus: any[]) => {
    rawMenus.value = menus
    sidebarMenus.value = processMenusForSidebar(menus)
    menusLoaded.value = true
  }

  // 从本地存储加载菜单
  const loadMenusFromStorage = () => {
    try {
      const menusFromStorage = localStorage.getItem("wuyemenusJSON")
      if (menusFromStorage) {
        const menus = JSON.parse(menusFromStorage)
        setMenus(menus)
        return menus
      }
    } catch (error) {
      console.error("Failed to load menus from storage", error)
    }
    return []
  }

  // 清空菜单数据
  const clearMenus = () => {
    rawMenus.value = []
    sidebarMenus.value = []
    menusLoaded.value = false
  }

  return {
    rawMenus,
    sidebarMenus,
    menusLoaded,
    setMenus,
    loadMenusFromStorage,
    clearMenus
  }
})